interface limiterTypes {
  strings?: any;
  limit?: number;
}

export function limiter({ strings = "", limit = 20 }: limiterTypes): string {
  return strings?.length > limit
    ? strings.substring(0, limit).concat("...")
    : strings || "-";
}
